export default __webpack_public_path__ + "static/media/highlight-off.a89e5be3.svg";